import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal, TemplateRef, viewChild } from '@angular/core';
import { NotificationItem } from '@models/notifications';
import { BRIEF_LENGTH, NotificationsService } from '@services/notifications.service';
import { resolveText } from '@utils/notifications';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, MbsPopupIcon, ModalService, ModalSettings, SidepanelComponent, SwitcherComponent } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-reseller-notifications-panel',
  templateUrl: './notifications-panel.component.html',
  styleUrls: ['./notifications-panel.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, NgClass, ButtonComponent, SidepanelComponent, SwitcherComponent, I18NextPipe]
})
export class NotificationsPanelComponent {
  private modalService = inject(ModalService);
  private i18n = inject(I18NextPipe);
  private detailsTemplate = viewChild<TemplateRef<unknown>>('detailsTemplate');

  protected notificationsService = inject(NotificationsService);
  protected readonly notifications = this.notificationsService.notifications;
  protected readonly selectedNotification = signal<NotificationItem>(null);

  protected getIconClasses(notification: NotificationItem): string {
    return `${MbsPopupIcon[notification.type]} text-${notification.type}`;
  }

  protected titleOf(notification: NotificationItem): string {
    return resolveText(notification?.title, notification?.titleKey, this.i18n);
  }

  protected messageOf(notification: NotificationItem): string {
    return resolveText(notification?.message, notification?.messageKey, this.i18n);
  }

  protected isLong(notification: NotificationItem): boolean {
    return this.messageOf(notification).length > BRIEF_LENGTH;
  }

  protected handleMutedChange(showNotifications: boolean): void {
    this.notificationsService.setMuted(!showNotifications);
  }

  protected showDetails(notification: NotificationItem): void {
    this.selectedNotification.set(notification);

    const settings: ModalSettings = {
      header: { title: this.titleOf(notification) || this.i18n.transform('notifications.detailsTitle') },
      footer: { okButton: { show: false }, cancelButton: { text: this.i18n.transform('notifications.close') } }
    };

    this.modalService.open(settings, this.detailsTemplate()).catch(() => null);
  }
}
